import React, {useState, useEffect} from 'react';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/material';
import Dialogo from '../../../componentes/herramientas/dialogo';
import DialogoR from '../../../componentes/herramientas/dialogo';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

import TablaMultiple from '../../../componentes/herramientas/tabla/tabla_multiple';

import { Ver_Valores, Form_todos, Titulos_todos, genera_formulario, conexiones, RetencionCompraExcell} from '../../../constantes';
import Reporte from '../../../componentes/reporte';
import RetencionPDF from '../../reportes/retencionpdf';

import Cargando from '../../../componentes/esperar/cargar';

import { removeAllListeners } from 'process';
import excel from '../../../imagenes/excel.png';
import CircularProgress from '@mui/material/CircularProgress';
import Formulario from '../../../componentes/herramientas/formulario';


function Retencion (props) {
    
    const [state, setState]= useState({esperar:true,Dialogo:{open:false}, Dialogo1:{open:false}});
    let datosR = [];
    const cambiarState = (nuevostate)=>{
        setState({...state, ...nuevostate, cambio:true})
    }
    
    const Condiciones = async(campo, datos) =>{
        let {valores}= datos
        
        Object.keys(valores).map(val=>{
            if(val.indexOf('titulo')!==-1){
                delete valores[val];
            }
            return val
        })
        
        return valores
        // switch (campo) {
           
        //     default:
        //         return valores;
        // }
    
    }

    const Abrir_retencion = async(valores, descargar=false)=>{
            
        setState({
            ...state,
            Dialogo:{            
                ...state.Dialogo, 
                open: !state.Dialogo.open,
                // tam:'xl',
                Titulo: `Retención: ${valores.numero} `,
                Cuerpo: <Reporte  
                                datos={valores} 
                                descargar={descargar} nombredoc={valores.numero} 
                                reporte={RetencionPDF} sizePagina= {{width:612, height:396}} 
                                cerrar={()=>setState({...state, Dialogo:{...state,Dialogo,open:false}})}
                        />,
                Cerrar: ()=>setState({...state, Dialogo:{...state,Dialogo,open:false}}),
            }
        })

    }
    
    const Titulo = (dato)=>{
        const texto = dato._id ? `Retención ${dato.numero}`: `Nueva Retención`
        return <Stack
                    direction={ 'row' }
                    spacing={1}
                    justifyContent="center" alignItems="center"
                >
                    {texto}
                    {dato._id
                        ?   <div>
                                <IconButton size="large" color="inherit" title={'Mostrar Retención'} onClick={()=>Abrir_retencion(dato)}>
                                    <Icon >text_snippet</Icon>
                                </IconButton>
                                <IconButton size="large" color="inherit" title={'Descargar Retención'} onClick={()=>Abrir_retencion(dato, true)}>
                                    <Icon >download</Icon>
                                </IconButton>
                            </div>
                        :null
                    }
                </Stack>

    }
    const verRetenciones= async()=>{
        let FInicio= new Date(state.fecha.getFullYear(), state.fecha.getMonth(),1);;
        
        let FFin = new Date(FInicio.getFullYear(), FInicio.getMonth()+1,0);
        FFin.setHours(23);
        FFin.setMinutes(59);
        FFin.setSeconds(59)
        console.log('por aqui', FInicio.toISOString(), FFin.toISOString());
        let respuesta= await conexiones.Leer_C(['uecla_Retencion'], 
            {
                uecla_Retencion:{$and:[{'valores.fecha': { $gte: FInicio.toISOString(), $lte: FFin.toISOString()}}  ]},
            }
        );
        let datos = []
        if (respuesta.Respuesta==='Ok'){
            datos = respuesta.datos.uecla_Retencion
        }
        datosR=datos;
        return datos
    }
    const Cambio_fecha = async (valores)=>{
        console.log('Vlaldldldlldld', valores)
        const inicio =valores['$d'];
        Actualizar(inicio)
    }
    const Actualizar = async(FInicio)=>{
        cambiarState({esperar:true});
        const titulos = await Titulos_todos(`Titulos_Retencion`, Config)
        let formulario = await genera_formulario({valores:{inicio: FInicio}, campos: {...Form_todos('Form_fecha_recibo')} })
        // formulario.titulos[0].value.inicio.= Cambio_fecha;
        formulario.titulos[0].value.inicio.label="Fecha";
        formulario.titulos[0].value.inicio.title="Fecha de Retenciones";
        formulario.titulos[0].value.inicio.vista=['month', 'year']
        formulario.titulos[0].value.inicio.onAccept= Cambio_fecha;
        delete formulario.titulos[0].value.fin
        cambiarState({esperar:false, formulario, fecha: FInicio, titulos})
    }
    const Inicio = async() =>{
        
        let FInicio= new Date();
        // FInicio.setDate(1);
        // let formulario = await genera_formulario({valores:{inicio: FInicio}, campos: Form_todos('Form_fecha_recibo') })
        // // formulario.titulos[0].value.inicio.= Cambio_fecha;
        // formulario.titulos[0].value.inicio.label="Fecha";
        // formulario.titulos[0].value.inicio.title="Fecha de Retenciones";
        // formulario.titulos[0].value.inicio.vista=['month', 'year']
        // formulario.titulos[0].value.inicio.onAccept= Cambio_fecha;
        // delete formulario.titulos[0].value.fin
        // cambiarState({esperar:false, titulos, formulario, fecha: FInicio})
        // cambiarState({titulos})
        Actualizar(FInicio)
    } 
    
    let buscado;
    const Actualizar_data = (valores)=>{
        if (valores.length!==0)
            buscado=valores;
        // cambiarState({buscado:valores})
    }
    
    const ordenar = (dato)=>{
        const nuevo = dato.filter(f=> f.valores).sort((a,b)=> a.valores.numero>b.valores.numero ? -1 :1)
        //datosR= nuevo;
        return nuevo
    }

    useEffect(()=>{
        Inicio()
        return ()=>{
            removeAllListeners(Inicio)
        }
    }, [props])

    const CrearLibro = async(valores)=>{
        console.log('valores', valores);
    }
    const LibroCompra = async() =>{
        
        RetencionCompraExcell(datosR,state.fecha,)
    }
    const {Config}= props;
    const color =  props.Config.Estilos.Input_icono_t ? props.Config.Estilos.Input_icono_t : {};
    const alto = Ver_Valores().tipo==='Web' 
            ?   window.innerHeight * 0.70
            :   window.innerHeight * 0.68

    console.log(state.titulos)
    return state.esperar ? <Cargando open={state.esperar} Config={Config}/> : (
        <Box>
            <TablaMultiple
                ordenar ={ordenar}
                alto={alto}
                BuscarDatos={verRetenciones}
                Config={Config ? Config : Ver_Valores().config}
                multiples_valores={true}
                Agregar_mas={false}
                Condiciones={Condiciones}
                Columnas={2} 
                Form_origen = {Form_todos(`Form_Retencion`, Config)}
                Titulo_tabla={'Retenciones'}
                Table = {'uecla_Retencion'}
                Eliminar_props={(dato)=>{
                    return `Desea eliminar retención ${dato.codigo}`
                }}
                Titulo_dialogo ={Titulo}
                Titulos_tabla = {state.titulos}
                cargaporparte = {true}
                sinpaginacion = {true}
                cargacompleta={Actualizar_data}
                Tam_dialogo={'xl'}
                AgregarAccion={
                    <Stack direction="row" spacing={1}>
                       <IconButton color={'primary'} title={'Libro de Compra'} onClick={ LibroCompra }>
                            {state.cargando 
                                ? <CircularProgress  />
                                : <img alt={'excel'} src={excel} height={35}/>
                            }
                        </IconButton>
                        {state.formulario 
                                                        ?   <Box sx={{width:window.innerWidth * 0.2}}>
                                                                
                                                                    <Formulario {...state.formulario} 
                                                                                config={{...Ver_Valores().config,
                                                                                    Estilos:{
                                                                                        Input_label:{color:'#fff'}
                                                                                    }
                                                                                }}
                                                                    /> 
                                                                
                                                            </Box>
                                                        : null}
                    </Stack>
                }
                
            />
            <Dialogo {...state.Dialogo} config={Config}/>
            <DialogoR {...state.Dialogo1} config={Config}/>
        </Box>
    )
}

export default Retencion;